import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { ApiService, EventsService, PaymentV2Service, UtilService, VariablesService } from '../../shared/services';

@Component({
  selector: 'app-offer-card',
  templateUrl: './offer-card.component.html',
  styleUrls: ['./offer-card.component.scss']
})
export class OfferCardComponent implements OnInit, OnDestroy {

  @Input() config = {
    offerAmount: 100,
    currency: 'INR'
  };

  userData;
  couponApplied = false;

  showOffer = true;
  campaignId;

  subs: Subscription[] = [];

  constructor(
    public util: UtilService,
    public vars: VariablesService,
    private events: EventsService,
    private apiService: ApiService,
    private paymentV2: PaymentV2Service,
    private actRoute: ActivatedRoute
  ) { }

  ngOnInit() {
    this.onInItSysEvent();
    this.campaignId = this.actRoute.snapshot.queryParams.fmd_id || this.campaignId;
    if (typeof document !== 'undefined' && this.vars.showCouponOffer) {
      document.body.classList.toggle('noscroll', true);
    }

    this.subs.push(this.vars.userData.subscribe(res => {
      this.userData = res;
      if (!this.couponApplied && this.actRoute.snapshot.queryParams.st === 'f' && this.actRoute.snapshot.queryParams.offer) {
        this.applyCoupon();
      }
    }));

    this.subs.push(this.paymentV2.paymentConfig.subscribe((config) => {
      this.campaignId = this.util.checkNestedObj(config, 'paymentDetails.campaign.id') || this.campaignId;
      if (!this.couponApplied && this.actRoute.snapshot.queryParams.st === 'f' && this.actRoute.snapshot.queryParams.offer) {
        this.applyCoupon();
      }
    }));
  }

  onInItSysEvent() {
    this.events.sendSystemEvent({
      eventName: 'sip_offer_popup',
      page_name: this.vars.pageName,
    }).subscribe(_ => _);
  }

  applyCoupon() {
    if (!this.campaignId || !this.userData) {
      return;
    }
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('noscroll', false);
    }
    this.vars.offerActivated.next(this.config.offerAmount);
    this.util.router.navigate([], {
      queryParams: {
        coupon: 'sip_' + this.config.offerAmount,
        offer: this.config.offerAmount,
        currency: this.config.currency
      },
      queryParamsHandling: 'merge'
    });
    this.couponApplied = true;
    this.apiService.applyCoupon(this.campaignId, { coupon_id: this.config.offerAmount === 100 ? 47 : 24 }).subscribe(() => { });
    this.sendEvent();
    this.util.scrollIntoViewSmoothlyByClass('offer-scroll');
    this.closeDialog();
  }


  sendEvent() {
    this.events.sendSystemEvent({
      eventName: 'sip_offer_clicked',
      // info_1: 'position',
      page_name: this.vars.pageName,
      // info_3: 'impact',
    }).subscribe(_ => _);
  }

  closeDialog() {
    if (typeof document !== 'undefined') {
      document.body.classList.toggle('noscroll', false);
    }
    this.vars.showCouponOffer = false;
  }

  ngOnDestroy() {
    this.subs.forEach(s => s.unsubscribe());
  }
}
